module.exports = __webpack_public_path__ + "img/keyBuckle_3.919cc6ed.jpg";